import * as tslib_1 from "tslib";
import * as React from 'react';
import { observer, inject } from 'mobx-react';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import FontIcon from 'material-ui/FontIcon';
var styles = {
    container: {
        padding: 10,
        overflowX: 'hidden'
    },
    row: {
        margin: '0 5px',
        display: 'flex'
    },
    dropdown: {
        fontSize: '14px',
        flex: 1,
        top: '-13px',
        height: '56px',
        lineHeight: '56px',
    },
    dropdownUnderline: {
        width: '120%',
        marginLeft: '-50px'
    }
};
var TaskCheckList = /** @class */ (function (_super) {
    tslib_1.__extends(TaskCheckList, _super);
    function TaskCheckList(props) {
        var _this = _super.call(this, props) || this;
        _this.handleStatusChange = function (event, item, value) {
            event.preventDefault();
            item.setStatus(value);
        };
        _this.handleNoteChange = function (event, item) {
            event.preventDefault();
            item.setNote(event.target.value);
        };
        return _this;
    }
    TaskCheckList.prototype.render = function () {
        var _this = this;
        var statuses = this.props.taskStore.checkListStatuses;
        var items = this.props.items.map(function (item) {
            return React.createElement("div", { key: item.id, style: styles.row },
                React.createElement(FontIcon, { color: item.color, className: "material-icons" }, item.icon),
                React.createElement(SelectField, { disabled: _this.props.isReadonly, value: item.statusId, style: styles.dropdown, underlineStyle: styles.dropdownUnderline, onChange: function (event, index, value) { return _this.handleStatusChange(event, item, value); } }, statuses.map(function (i) {
                    return React.createElement(MenuItem, { key: i.id, primaryText: item.name + " (" + i.name + ")", value: i.id });
                })));
        });
        return (React.createElement("div", { style: styles.container }, items));
    };
    TaskCheckList = tslib_1.__decorate([
        inject('taskStore'),
        observer
    ], TaskCheckList);
    return TaskCheckList;
}(React.Component));
export { TaskCheckList };



//////////////////
// WEBPACK FOOTER
// ./src/pages/tasks/TaskCheckList.tsx
// module id = 733
// module chunks = 0